import "./CricketMatchCard.css";

function CricketMatchCard({ match }) {
  const team1 = match.teamInfo?.[0]?.shortname || match.teams?.[0];
  const team2 = match.teamInfo?.[1]?.shortname || match.teams?.[1];

  const isLive = match.matchStarted && !match.matchEnded;
  const isEnded = match.matchEnded;

  return (
    <div className={`cricket-card ${isLive ? "live" : ""}`}>
      {/* HEADER */}
      <div className="match-header">
        <span className="match-type">{match.matchType.toUpperCase()}</span>

        {isLive && <span className="live-badge">LIVE</span>}
      </div>

      {/* TEAMS */}
      <h4 className="teams">
        {team1} <span className="vs">vs</span> {team2}
      </h4>

      {/* SCORES */}
      <div className="scores">
        {match.score?.map((s, idx) => (
          <div key={idx} className="score-line">
            <span>{s.inning}</span>
            <span>
              {s.r}/{s.w} ({s.o} ov)
            </span>
          </div>
        ))}
      </div>

      {/* STATUS */}
      <p
        className={`status ${
          match.status?.toLowerCase().includes("won")
            ? "won"
            : isEnded
            ? "ended"
            : ""
        }`}
      >
        {match.status}
      </p>

      <p className="venue">{match.venue}</p>
    </div>
  );
}

export default CricketMatchCard;
